// extracted by mini-css-extract-plugin
module.exports = {"container":"CloseButton_container__2rPAI","darkTheme":"CloseButton_darkTheme__3HPXz","lightTheme":"CloseButton_lightTheme__cThWV"};